import React from 'react'

const About = () => {
    return (
        <div className='about'>
           <h1>About App</h1>
           <p className='lead'> This app is made to search users on Github using Github API</p>
           <p>This app is made using React JS with Context API</p>
        </div>
    )
}

export default About
